// extracted by mini-css-extract-plugin
module.exports = {"header":"UnsupportedMessage_header__2Vzp6","title":"UnsupportedMessage_title__12F3Y","description":"UnsupportedMessage_description__3oDWv"};